// @flow
import * as mediaServer from 'Components/utils/media-server';

type Params = {
  id: string,
  url: string,
  width1x: number,
  width2x: number,
};

type GetUrlFunction = (url: string, width: number) => string;
type GetRuleFunction = (
  params: Params,
) => (getUrlFunction: GetUrlFunction) => (prefixes: Array<string>) => string;

const AUTO = '_AUTOFORMAT_';
const PREFIXES = ['webkit', 'moz', 'o', 'ms'];

function getBackgroundImageUrl(url: string, width: number): string {
  const options = {
    format: AUTO,
    url,
    width,
    height: 'auto',
    transform: 'resize',
    quality: 70,
  };
  return mediaServer.getUrl(options);
}

function getBackgroundRule(params: Params) {
  return (getUrlFunction: GetUrlFunction) => {
    return (prefixes: Array<string>) => {
      const { id, url, width1x, width2x } = params;

      return `.${id} {
        background-image:url(${getUrlFunction(url, width1x)});
        ${prefixes.reduce(
          (acc, prefix) => `${acc}
        background-image: -${prefix}-image-set(url(${getUrlFunction(
            url,
            width1x,
          )}) 1x, url(${getUrlFunction(url, width2x)}) 2x);
        `,
          '',
        )}
      }`;
    };
  };
}

function getAllBackgroundRules(params: Params) {
  return (getRuleFunction: GetRuleFunction) => {
    return `${getRuleFunction(params)(getBackgroundImageUrl)(PREFIXES)}`;
  };
}

export { getBackgroundImageUrl, getBackgroundRule, getAllBackgroundRules, AUTO, PREFIXES };
